import {SagaIterator} from 'redux-saga';
import {put, select, cancelled} from 'typed-redux-saga';
import {putAll, takeLatestF} from 'favorlogic-utils';

import {StoreState} from 'app/types/StoreState';

import {reset} from '../actions';

function* execute(): SagaIterator {
    const action = yield* select((x: StoreState) => x.confirmDialog.cancelAction);

    if (action.isSome())  {
        yield putAll(action.value);
    } else {
        yield* cancelled();
    }

    yield* put(reset());
}

export function* cancelSaga(): SagaIterator {
    yield takeLatestF('confirmDialog/CANCEL', execute);
}
